/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'

import { giveElementFeedbackJSX } from '../../analysisJSX/giveElementFeedbackJSX'
import { viewFeedbackAndVerdictForItemJSX } from '../../analysisJSX/viewFeedbackAndVerdictForItemJSX'
import { viewFeedbackGeneralAnalysisJSX } from '../../analysisJSX/viewFeedbackGeneralAnalysisJSX'
import { viewFeedbackScorecardJSX } from '../../analysisJSX/viewFeedbackScorecardJSX'
import { viewBumbleVitalInfoItem } from './jsx/viewBumbleVitalInfoItemJSX'
import { viewBumbleImageItem } from './jsx/viewBumbleImageItemJSX'
import { viewBumblePromptItem } from './jsx/viewBumblePromptItemJSX'
import { viewBumbleVitalInfoLocation } from './jsx/viewBumbleVitalInfoItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, bumbleProfileBackgroundColor, swipelyticsTurquoise, profPicDefaultURL } from '../../../../helpers/variableDefaults'
import { standardSpinner } from '../../../../helpers/spinners'
import { TabPanel } from '../../../../helpers/formatting'


export const viewBumbleProfileJSX = (viewFeedbackTrue, giveFeedbackTrue, isFriendReview, datingProfile, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview) => {
  
  return (
    <Box sx={{ 
      // backgroundColor: 'yellow',
      mt: 0, mb: 0, 
      width: width >= positionChangeWidthSm ? '90vw' : '100vw', 
      maxWidth: positionChangeWidthSm, 
      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
    }}>
      <Box
        sx={{
          mt: 2, mb: (giveFeedbackTrue || viewFeedbackTrue) ? 2 : 4, py: 3, px: 2,
          backgroundColor: bumbleProfileBackgroundColor,
          // backgroundColor: 'black',
          width: '100%', 
          // maxWidth: '600px',
          maxWidth: '400px',
          boxShadow: width >= positionChangeWidthSm ? 3 : 3, 
          borderRadius: width >= positionChangeWidthSm ? 3 : 0,
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
        }}
      >

        {/* Image 1 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 0 
          && 
            viewBumbleImageItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              0, 
              datingProfile, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Image 1  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 0 
          && 'feedback' in datingProfile.mediaFeedback[0] 
          && 'verdict' in datingProfile.mediaFeedback[0] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            0, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Vital Info — Part 1 */}
        {'bio' in datingProfile
          && 'vitalInfo' in datingProfile.bio
          && Object.keys(datingProfile.bio.vitalInfo).length > 0
          &&
            viewBumbleVitalInfoItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              isFriendReview,
              user, 
              datingProfile, 
              setProfileReview, 
              width, 
              errors, 
              setErrors, 
              loading, 
              setLoading
            )
        }

        {/* Feedback — Vital Info  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'vitalInfoFeedback' in datingProfile.bioFeedback 
          && 'feedback' in datingProfile.bioFeedback.vitalInfoFeedback 
          && 'verdict' in datingProfile.bioFeedback.vitalInfoFeedback 
          && 
          giveElementFeedbackJSX(
            'vitalInfo', 
            -1, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Image 2 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 1 
          && 
            viewBumbleImageItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              1, 
              datingProfile, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Image 2  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 1 
          && 'feedback' in datingProfile.mediaFeedback[1] 
          && 'verdict' in datingProfile.mediaFeedback[1] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            1, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Prompt 1 */}
        {'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length > 0
          && datingProfile.bio.prompts[0].prompt !== '' 
          && datingProfile.bio.prompts[0].prompt !== 'No Prompt' 
          && datingProfile.bio.prompts[0].response !== ''
          &&
            viewBumblePromptItem(
              viewFeedbackTrue,
              giveFeedbackTrue, 
              0, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Prompt 1  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'promptsFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.promptsFeedback.length > 0 
          && 'feedback' in datingProfile.bioFeedback.promptsFeedback[0] 
          && 'verdict' in datingProfile.bioFeedback.promptsFeedback[0] 
          && 
          giveElementFeedbackJSX(
            'prompt', 
            0, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Image 3 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 2 
          && 
            viewBumbleImageItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              2, 
              datingProfile, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Image 3  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 2 
          && 'feedback' in datingProfile.mediaFeedback[2] 
          && 'verdict' in datingProfile.mediaFeedback[2] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            2, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Prompt 2 */}
        {'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length > 1
          && datingProfile.bio.prompts[1].prompt !== '' 
          && datingProfile.bio.prompts[1].prompt !== 'No Prompt' 
          && datingProfile.bio.prompts[1].response !== ''
          &&
            viewBumblePromptItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              1, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Prompt 2  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'promptsFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.promptsFeedback.length > 1 
          && 'feedback' in datingProfile.bioFeedback.promptsFeedback[1] 
          && 'verdict' in datingProfile.bioFeedback.promptsFeedback[1] 
          && 
          giveElementFeedbackJSX(
            'prompt', 
            1, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }


        {/* Image 4 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 3 
          && 
            viewBumbleImageItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              3, 
              datingProfile, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Image 4  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 3 
          && 'feedback' in datingProfile.mediaFeedback[3] 
          && 'verdict' in datingProfile.mediaFeedback[3] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            3, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Prompt 3 */}
        {'bio' in datingProfile
          && 'prompts' in datingProfile.bio
          && datingProfile.bio.prompts.length > 2
          && datingProfile.bio.prompts[2].prompt !== '' 
          && datingProfile.bio.prompts[2].prompt !== 'No Prompt' 
          && datingProfile.bio.prompts[2].response !== ''
          &&
            viewBumblePromptItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              2, 
              datingProfile, 
              width
            )
        }

        {/* Feedback — Prompt 3  */}
        {giveFeedbackTrue
          && 'bioFeedback' in datingProfile 
          && datingProfile.bioFeedback !== null 
          && 'promptsFeedback' in datingProfile.bioFeedback 
          && datingProfile.bioFeedback.promptsFeedback.length > 2 
          && 'feedback' in datingProfile.bioFeedback.promptsFeedback[2] 
          && 'verdict' in datingProfile.bioFeedback.promptsFeedback[2] 
          && 
          giveElementFeedbackJSX(
            'prompt', 
            2, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Image 5 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 4 
          && 
            viewBumbleImageItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              4, 
              datingProfile, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Image 5  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 4 
          && 'feedback' in datingProfile.mediaFeedback[4] 
          && 'verdict' in datingProfile.mediaFeedback[4] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            4, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* Image 6 */}
        {'media' in datingProfile 
          && datingProfile.media !== null 
          && datingProfile.media.length > 5 
          && 
            viewBumbleImageItem(
              viewFeedbackTrue, 
              giveFeedbackTrue,
              5, 
              datingProfile, 
              showSubcaption, 
              setShowSubcaption, 
              mediaIsLoading, 
              setMediaIsLoading, 
              width
            )
        }

        {/* Feedback — Image 6  */}
        {giveFeedbackTrue
          && 'mediaFeedback' in datingProfile 
          && datingProfile.mediaFeedback !== null 
          && datingProfile.mediaFeedback.length > 5 
          && 'feedback' in datingProfile.mediaFeedback[5] 
          && 'verdict' in datingProfile.mediaFeedback[5] 
          && 
          giveElementFeedbackJSX(
            'mediaItem', 
            5, 
            isFriendReview,
            datingProfile, 
            setProfileReview, 
            width, 
            errors, 
            setErrors, 
            loading, 
            setLoading
          )
        }

        {/* My Location (Vital Info — Part 3) */}
        {'bio' in datingProfile
          && 'vitalInfo' in datingProfile.bio
          && Object.keys(datingProfile.bio.vitalInfo).length > 0
          &&
          viewBumbleVitalInfoLocation(
            viewFeedbackTrue, 
            giveFeedbackTrue,
            isFriendReview,
            user, 
            datingProfile, 
            width
          )
        }

        {/* Analysis */}
        {viewFeedbackTrue 
          && 'generalFeedback' in datingProfile 
          && Object.keys(datingProfile.generalFeedback).length > 0
          && 
          (
            ('vibe' in datingProfile.generalFeedback && datingProfile.generalFeedback.vibe.length > 0)
            || ('good' in datingProfile.generalFeedback && datingProfile.generalFeedback.good.length > 0)
            || ('notGood' in datingProfile.generalFeedback && datingProfile.generalFeedback.notGood.length > 0)
            || ('verdict' in datingProfile.generalFeedback && datingProfile.generalFeedback.verdict.length > 0)
          )
          &&
          viewFeedbackGeneralAnalysisJSX(datingProfile.type, datingProfile.generalFeedback, datingProfile.bio.vitalInfo, width)
        }

        {/* Scorecard */}
        {/* {console.log('datingProfile.mediaFeedback.length ->', datingProfile)} */}
        {viewFeedbackTrue 
          && 'mediaFeedback' in datingProfile && datingProfile.mediaFeedback.length > 0 &&
          viewFeedbackScorecardJSX(datingProfile.type, datingProfile.mediaFeedback, datingProfile.bioFeedback, width)
        }
      </Box>
    </Box>
  )
}

export const viewBumbleProfileTabJSX = (value, index, giveFeedbackTrue, isFriendReview, datingProfile, user, showSubcaption, setShowSubcaption, mediaIsLoading, setMediaIsLoading, loading, setLoading, errors, setErrors, width, setProfileReview) => {

  return (
    <TabPanel value={value} index={index}>
      {loading.loading ?
        standardSpinner()
        : 
        viewBumbleProfileJSX(
          giveFeedbackTrue && datingProfile.reviewSubmitted ? true : false, 
          giveFeedbackTrue && datingProfile.reviewSubmitted ? false : giveFeedbackTrue,
          isFriendReview,
          datingProfile,
          user, 
          showSubcaption, 
          setShowSubcaption, 
          mediaIsLoading, 
          setMediaIsLoading,
          loading, 
          setLoading, 
          errors, 
          setErrors, 
          width,
          setProfileReview
        )
      }
    </TabPanel>
  )
}